export function searchSuffix(searchParams: URLSearchParams): string {
  const query = searchParams.toString();
  return query === '' ? '' : `?${query}`;
}
